<template>
    <div>
        <div class="chartContainer">
            <h1>Salg per måned</h1>
            <div class="chart">
                <div id="salesPerMonthChart"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApexCharts from 'apexcharts'
    export default{
        props:{
            chart_data: Object,
            last_year_data: Object
        },
        mounted(){
            console.log(this.chart_data)
            this.MakeCharts(this.chart_data, this.last_year_data);
        },
        methods: {
            MakeCharts(chart_data, last_year_data) {     
                var barOptions = {
                    chart: {
                        type: 'bar',
                        toolbar: {
                            show: true
                        },
                        zoom: {
                            enabled: true
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                        },
                    },
                    series: [{
                        name: (new Date()).getFullYear() - 1,
                        data: Object.values(this.last_year_data)
                    },{
                        name: (new Date()).getFullYear(),
                        data: Object.values(this.chart_data)
                    }],
                    xaxis: {
                        categories: MONTH_NAMES,
                    },
                    yaxis: {
                        y: 10000
                    },
                    fill: {
                        opacity: 1
                    },
                }
                var barChart = new ApexCharts(document.querySelector("#salesPerMonthChart"), barOptions);
                barChart.render();  
            },
            ToTimestamp(strDate){
                var datum = Date.parse(strDate);
                return datum;
            }
        }
    }

    
</script>



// WEBPACK FOOTER //
// resources/js/components/SalesPerMonthChart.vue